export const isSafariBrowser = (): boolean => {
  return navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1;
};

export const isMobileOrTablet = (): boolean => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const isMobileIOS = (): boolean => {
  return /iPad|iPhone|iPod/i.test(navigator.userAgent) && !(window as any).MSStream;
};
